import { Location, useLocation } from "react-router";

import { StripeCheckoutStatus } from "src/types";

type CheckoutState = {
  checkoutSuccess?: StripeCheckoutStatus;
  email?: string;
} | null;

export const useCheckoutResult = () => {
  const location = useLocation() as Location & { state: CheckoutState };
  const { checkoutSuccess, email } = location.state ?? {};

  return { checkoutSuccess, email };
};
